import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/TimeExpiredIllustration.tsx
const TimeExpiredIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "time-expired.svg",
		alt: t("illustration.imageAlt.expiredTime")
	});
};

//#endregion
export { TimeExpiredIllustration };